import styled from "styled-components"

export const HeaderContainer = styled.div<{ withExtraMarginBottom?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 16px 0;
    position: relative;
    margin-bottom: ${(props) => (props.withExtraMarginBottom ? "18px" : "0")};
`

export const BackButtonContainer = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;

    &:hover {
        opacity: 0.7;
    }

    &:focus-visible {
        outline: 2px solid #503abd;
        outline-offset: 2px;
        border-radius: 4px;
    }

    i {
        font-size: 14px;
        color: #495057;
    }
`

export const BackButtonText = styled.span`
    font-family: "Roboto", sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    color: #495057;
    white-space: nowrap;
`

export const PageTitle = styled.h1`
    font-family: "Roboto", sans-serif;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.3;
    color: #000000;
    margin: 0;
    white-space: nowrap;
    text-align: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
`
